export default __webpack_public_path__ + "static/media/kdeconjugate.196720a8.png";